module.exports = __webpack_public_path__ + "static/media/delet.5f354804.svg";